import '../App.css';
import React, { useState, useEffect } from "react";
import { Row, Col, Container } from 'react-bootstrap';
import 'bootstrap/dist/css/bootstrap.min.css'
import { BrowserRouter as Router, Route, Routes, Link } from 'react-router-dom';
import pdf from '../pdfs/quadraturemedal.pdf'; 
import { Helmet } from 'react-helmet';
import QuadratureMedalMobile from '../images/quadraturemedal.png';

function QuadratureMedal() {
  const [isMobile, setIsMobile] = useState(window.innerWidth < 768);
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth < 768);
    };

    window.addEventListener('resize', handleResize);

    return () => {
      window.removeEventListener('resize', handleResize);
    };
  }, []);

  function renderLinks() {
    return (
      <div style={{lineHeight: isMobile ? '1' : '', fontSize: isMobile ? '15px' : ''}}>
        Source:<br /><br />
        Manuscript held by G. W. Leibniz Bibliothek, Hanover<br />
        Shelfmark LH 35, 2, 1 Bl. 2r<br /><br />
        {isMobile ? '' : <hr className="centered-hr" />}
        Date: unknown<br /><br />
        Translated from the Latin<br /><br /> 
        {isMobile ? '' : <hr className="centered-hr" />}
        <Link to={pdf} target="_blank">View this translation in PDF format (226k)</Link>
        <br></br><br></br>
      </div>
    );
  }
  
  return (
    <div>
        <Helmet>
            <title>Memorial Medal of Quadrature and Arithmetic Machine</title>
            <meta name="description" content="An English translation of MEMORIAL MEDAL OF QUADRATURE AND ARITHMETIC MACHINE by Gottfried Wilhelm Leibniz, from 1677 - 1682 (?)" />
        </Helmet>
        <Routes>
          <Route path="/" element={
            <Container fluid className="Container">
              <Row className="main-content">
                <Col md={3} className={`LeftColumn ${isMobile ? 'mobile' : ''}`}>
                  {isMobile ? (
                    <></>
                  ) : (
                    <>
                    {renderLinks()}
                 
                    </>
                  )}
                </Col>
                <Col md={8} className={`RightColumn ${isMobile ? 'mobile' : ''}`}>
                  <td className="pdf-container">
                    <h2 className={`PageTitle ${isMobile ? 'mobile' : ''}`}>LEIBNIZ: MEMORIAL MEDAL OF QUADRATURE AND ARITHMETIC MACHINE</h2>
                    {isMobile ? renderLinks() : ''}
                    {isMobile ? <img src={QuadratureMedalMobile} width="100%"/> : <embed src={pdf} className="responsive-embed"/>}
		              </td>
                </Col>
                <Col md={1}></Col>
              </Row>
              <Row className="footer"><h6>&copy; LLOYD STRICKLAND 2003-{new Date().getFullYear()}</h6></Row>
            </Container>
          } />
        </Routes>
      </div>
  );
}

export default QuadratureMedal;